import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import type IApiUserData from 'core/models/api-user-data'
import { useGlobalFiltersStore } from './useGlobalFiltersStore'

interface HomeFiltersState {
  channel: 'INSTORE' | 'OMNI'
  aggregation: 'STORE' | 'TEAM'
  teamId: number | null
  syncWithUserPreferences: (user: IApiUserData) => void
  setChannel: (channel: 'INSTORE' | 'OMNI') => void
  setAggregation: (aggregation: 'STORE' | 'TEAM') => void
  setTeamId: (teamId: number | null) => void
}

const MY_GAME_FILTERS_STORAGE_KEY = 'mg-home-filters'

const DEFAULT_FILTERS_STATE = {
  channel: 'INSTORE' as const,
  aggregation: 'STORE' as const,
  teamId: null
}

export const useHomeFiltersStore = create<HomeFiltersState>()(
  persist(
    set => ({
      ...DEFAULT_FILTERS_STATE,
      syncWithUserPreferences: user =>
        set(state => ({
          teamId: state.teamId ?? user?.preferences?.default_filters?.team ?? null
        })),
      setChannel: channel => set({ channel }),
      setAggregation: aggregation => set({ aggregation }),
      setTeamId: teamId => set({ teamId })
    }),
    {
      name: MY_GAME_FILTERS_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({
        channel: state.channel,
        aggregation: state.aggregation,
        teamId: state.teamId
      })
    }
  )
)

useGlobalFiltersStore.subscribe((state, previousState) => {
  if (state.storeId === previousState.storeId) {
    return
  }

  useHomeFiltersStore.setState(currentState => ({
    ...currentState,
    teamId: null
  }))
})

export const resetHomeFiltersStore = () => {
  useHomeFiltersStore.setState(DEFAULT_FILTERS_STATE)
}
